import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatDialogModule } from '@angular/material/dialog'
import { RouterModule } from '@angular/router'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { SharedModule } from '@shared/shared.module'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { languagesRoutes } from './languages.routing'
import { COUNTRIES, countries } from './languages/languages-crud/countries'
import { LanguagesCrudComponent } from './languages/languages-crud/languages-crud.component'
import { LanguagesListComponent } from './languages/languages-list/languages-list.component'
import { LanguagesComponent } from './languages/languages.component'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    LanguagesComponent,
    LanguagesListComponent,
    LanguagesCrudComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(languagesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    SharedModule,
    ContentEditableModule,
    CommonModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    SweetAlert2Module,
    ContentEditableModule,
    MatDialogModule,
    BreadcrumbsModule,
  ],
  providers: [{ provide: COUNTRIES, useValue: countries }],
})
export class LanguagesModule {}
